// src/utils/analytics.js

const analytics = {
  // Enkel og sikker tracking funksjon
  track: (eventName, data = {}) => {
    // Sjekk om gtag er tilgjengelig
    if (typeof window !== 'undefined' && window.gtag) {
      try {
        window.gtag('event', eventName, {
          event_category: 'Gift Finder',
          ...data
        });
        
        // Debug logging i development
        if (process.env.NODE_ENV === 'development') {
          console.log('📊 Analytics Event:', eventName, data);
        }
      } catch (error) {
        console.warn('Analytics error:', error);
      }
    } else {
      // Lagre til senere hvis gtag ikke er klar
      console.log('⏳ Analytics queued:', eventName, data);
      setTimeout(() => analytics.track(eventName, data), 1000);
    }
  },

  // Spesifikke tracking funksjoner for gavefinneren
  giftFinder: {
    started: () => analytics.track('gift_finder_started'),
    
    searched: (formData) => analytics.track('gift_search', {
      age: formData.age,
      budget: formData.budget,
      interests_count: formData.interests?.length || 0
    }),
    
    categorySelected: (categoryName) => analytics.track('category_selected', {
      category_name: categoryName
    }),
    
    productClicked: (productName, linkType) => analytics.track('external_link_click', {
      product_name: productName,
      link_type: linkType,
      value: 5
    }),
    
    resultsShown: (resultCount) => analytics.track('search_results_shown', {
      result_count: resultCount,
      value: resultCount
    })
  }
};

export default analytics;